
<template>
  <div class="my-card-list">
    <div
      class="my-card-item"
      v-for="(item, index) in chargeList[type]"
      :key="index"
    >
      <div class="my-card-title">{{ item.title }}</div>
      <div class="my-card-flex">
        <template v-for="(child, i) in item.list">
          <div
            :key="child.icon + i"
            class="flex"
            v-if="
              !child.autoKey || (child.autoKey && configData[child.autoKey])
            "
          >
            <pi-card-block :item="child" @click="cardClick"></pi-card-block>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import cardBlock from "@/components/pi-card-block/pi-card-block";
export default {
  name: "pi-my-card-list",
  components: {
    [cardBlock.name]: cardBlock,
  },
  data() {
    return {
      chargeList: {
        user: [
          {
            title: "我的充电",
            list: [
              {
                name: "我的订单",
                icon: require("@/picture/my/my-order.png"),
                url: "/my/order",
              },
              {
                name: "关联电卡",
                icon: require("@/picture/my/my-card.png"),
                url: "/my/charge-card",
              },
              {
                name: "我的收藏",
                icon: require("@/picture/my/my-collection.png"),
                url: "/my/collection",
              },
            ],
          },
          {
            title: "我的服务",
            list: [
              {
                name: "车牌号码",
                icon: require("@/picture/my/my-car.png"),
                url: "/car-list",
              },
              {
                name: "发票管理",
                icon: require("@/picture/my/my-invoice.png"),
                url: "/my-invoice?type=2",
                type: "invoice",
              },
              {
                name: "会员权益",
                icon: require("@/picture/my/my-member.png"),
                url: "/my-member",
                autoKey: "openVip",
              },
              {
                name: "一号多充",
                icon: require("@/picture/my/my-one.png"),
                url: "/userinfo/card-multiple",
              },
              {
                name: "使用统计",
                icon: require("@/picture/my/my-statistics.png"),
                url: "/my/my-statistics?type=member",
              },
            ],
          },
          {
            title: "积分商城",
            list: [
              {
                name: "积分商城",
                icon: require("@/picture/my/my-integral.png"),
                url: "/points-mall",
                autoKey: "openMall",
              },
              {
                name: "商城订单",
                icon: require("@/picture/my/my-shopping-order.png"),
                url: "/points-order",
              },
              {
                name: "收货地址",
                icon: require("@/picture/my/my-address.png"),
                url: "/points-address",
              },
            ],
          },
          {
            title: "其他",
            list: [
              {
                name: "设置",
                icon: require("@/picture/my/my-set.png"),
                url: "/my/set-up",
              },
              {
                name: "客服中心",
                icon: require("@/picture/my/my-service.png"),
                url: "/my/service-center",
              },
              {
                name: "关于我们",
                icon: require("@/picture/my/my-about.png"),
                url: "/about",
              },
            ],
          },
        ],
        entAdmin: [
          {
            title: "企业充电",
            list: [
              {
                name: "个人订单",
                icon: require("@/picture/my/my-ent-user-order.png"),
                url: "/my/order",
                type: "entOrder",
              },
              {
                name: "统付订单",
                icon: require("@/picture/my/my-ent-pay-order.png"),
                url: "/my/order",
                type: "entAdminOrder",
                isEntPayOrder: true,
              },
              {
                name: "个付订单",
                icon: require("@/picture/my/my-ent-user-pay-order.png"),
                url: "/my/order",
                type: "entAdminOrder",
                isEntPayOrder: false,
              },
              {
                name: "发票管理",
                icon: require("@/picture/my/my-invoice.png"),
                url: "/my-invoice?type=1",
              },
            ],
          },
          {
            title: "充电服务",
            list: [
              {
                name: "使用统计",
                icon: require("@/picture/my/my-statistics.png"),
                url: "my/my-statistics?type=entAdmin",
              },
            ],
          },
        ],
        ent: [
          {
            title: "企业充电",
            list: [
              {
                name: "个人订单",
                icon: require("@/picture/my/my-ent-user-order.png"),
                url: "/my/order",
                type: "entOrder",
              },
              {
                name: "车牌号码",
                icon: require("@/picture/my/my-car.png"),
                url: "/car-list",
              },
            ],
          },
          {
            title: "充电服务",
            list: [
              {
                name: "使用统计",
                icon: require("@/picture/my/my-statistics.png"),
                url: "my/my-statistics?type=entPay",
              },
            ],
          },
        ],
        entUser: [
          {
            title: "企业充电",
            list: [
              {
                name: "个人订单",
                icon: require("@/picture/my/my-ent-user-order.png"),
                url: "/my/order",
                type: "entUserOrder",
              },
              {
                name: "车牌号码",
                icon: require("@/picture/my/my-car.png"),
                url: "/car-list",
              },
              {
                name: "发票管理",
                icon: require("@/picture/my/my-invoice.png"),
                url: "/my-invoice?type=2",
              },
            ],
          },
          {
            title: "充电服务",
            list: [
              {
                name: "使用统计",
                icon: require("@/picture/my/my-statistics.png"),
                url: "my/my-statistics?type=entPersonalPay",
              },
            ],
          },
        ],
      },
    };
  },
  props: {
    configData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    entData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    accountObj: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "user",
    },
  },
  methods: {
    cardClick(item) {
      this.cardClickOperation(item);
    },
    /**
     * 跳转
     */
    cardClickOperation(item) {
      if (item.type == "entAdminOrder") {
        // 企业管理员
        let data = {
          type: "entAdminOrder",
          entUserPkId: this.entData.entUserPkId,
          isEntPayOrder: item.isEntPayOrder,
        };
        this.$router.push("my/order?" + this.$common.parseParam(data));
      } else if (item.type == "entOrder") {
        //企业支付
        let data = {
          type: "entOrder",
          accountPkId: this.entData.accountPkId,
        };
        this.$router.push("my/order?" + this.$common.parseParam(data));
      } else if (item.type == "entUserOrder") {
        //企业个付
        let data = {
          type: "entUserOrder",
        };
        this.$router.push("my/order?" + this.$common.parseParam(data));
      } else {
        let url = item.url;
        if(url.indexOf('?') != -1){
          url = url + '&chargeUserPkId=' + this.accountObj.chargeUserPkId
        }else{
          url = url + '?chargeUserPkId=' + this.accountObj.chargeUserPkId
        }
        this.$router.push(url);
      }
    },
  },
};
</script>
<style lang="less" scoped>
.my-card-item {
  background: #ffffff;
  box-shadow: 0px 0px 0.1rem 0px #efeff4;
  border-radius: 0.16rem;
  font-size: 0.2rem;
  line-height: 0.28rem;
  margin-top: 0.2rem;
}
.my-card-title {
  padding: 0.3rem 0.2rem 0 0.2rem;
  color: #999999;
}
.my-card-flex {
  display: flex;
  flex-wrap: wrap;
}
.my-card-flex .flex {
  width: 25%;
}
</style>